export default __webpack_public_path__ + "static/media/Sanitation.23b71020.png";